import React, { useEffect, useState } from "react";
import Logo from "../../images/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InputGroup from "../../components/InputGroup";
import Toggle from "../../components/Toggle";
import axios from "../../helpers/axios";
import { useDispatch, useSelector } from "react-redux";
import { login, setAdminData } from "../../redux/slice/authSlice";
import { toast } from "react-toastify";

export default function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const admintoken = location.pathname.substring(15, location.pathname.length);
    const AdminLoggedData = JSON.parse(localStorage.getItem("AdminLoggedData"));
    const [data, setData] = useState({
        "remember_token": admintoken,
        "newpassword": "",
        "confirmpassword": ""
    });

    const [resetPwd, setresetPwd] = useState(false);
    const [resetLinkMsg, setresetLinkMsg] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const authInfo = useSelector((state) => state.auth);



    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            if (data.newpassword !== "" && data.confirmpassword !== "" && data.newpassword !== data.confirmpassword) {
                setError(true);
                return;
            } else {
                setError(false);
                setLoading(true);
                let res = await axios.post("admin/reset/password", data);
                if (res.data.resp_code === 200) {
                    setLoading(false);
                    toast.success(res.data?.message);
                    navigate("/login");
                }
            }
        } catch (error) {
            setLoading(false);
            toast.error("Password reset not completed..!")
        }

    };

    useEffect(() => {
        if (
            AdminLoggedData !== null &&
            AdminLoggedData !== undefined &&
            Object.keys(AdminLoggedData)?.length > 0
        ) {
            setData(AdminLoggedData);
        } else {
            setData({
                ...data,
                "newpassword": "",
                "confirmpassword": ""
            });
        }
    }, []);

    useEffect(() => {
        async function setAxios() {
            if (authInfo.token && authInfo.isLoggedIn) {
                await axios.interceptors.request.use(
                    async (config) => {
                        config.headers.Authorization = `Bearer ${authInfo.token}`;
                        return config;
                    },
                    (error) => {
                        //console.log("Token error", error.message);
                        return Promise.reject(error);
                    }
                );
                return navigate("/dashboard");
            }
        }
        setAxios();
    }, []);

    //console.log("resetPwd", data);
    return (
        <div className="md:grid md:grid-cols-5 md:h-screen">
            <div className="md:col-span-2 md:p-2 md:h-full">
                <div className="bg-loginBg h-full md:rounded-md content-end flex-col justify-end p-12 py-8 flex pt-40 relative overflow-hidden bg-center md:py-16">
                    <div className="container justify-end z-20">
                        <h1 className="text-2xl text-white font-bold mb-1">
                            Discover, Collaborate, Win
                        </h1>
                        <p className="text-sm text-white mb-4">
                            Discover customer pain points, Collaborate to achieve those using
                            OhhTo and get more bonus and get customers.
                        </p>
                        <button type="button" to={"/"} className="btn-xl">
                            View more
                        </button>
                    </div>
                    <div className="absolute w-full h-full z-10 bg-black opacity-70 left-0 top-0"></div>
                </div>
            </div>
            <div className="md:col-span-3 md:h-screen">
                <div className="h-auto md:h-full flex py-8">
                    <div className="my-auto  mx-auto w-full max-w-sm px-4 md:px-2">
                        <img src={Logo} className="mx-auto mb-8" />
                        <h1 className="text-xl font-bold text-center">Reset Password</h1>
                        <p className="text-sm text-gray-500 text-center"></p>
                        <form className="mt-12" autoComplete={"off"}>

                            <InputGroup
                                type="password"
                                label="Password"
                                placeholder="8+ Characters required"
                                value={data.password}
                                setValue={(value) =>
                                    setData((data) => ({
                                        ...data, newpassword: value
                                    }))
                                }
                                required={true}
                            />
                            <InputGroup
                                type="password"
                                label="Confirm Password"
                                placeholder="8+ Characters required"
                                value={data.confirmpassword}
                                setValue={(value) =>
                                    setData((data) => ({ ...data, confirmpassword: value }))
                                }
                                required={true}

                            />
                            {error ? (

                                <div className="text-center w-full">
                                    <p className="text-red-600 h-[20px] text-[14px] tracking-tight font-medium">
                                        {"The Passwords Donot Match"}
                                    </p>
                                </div>

                            ) : null}
                            <div className="relative mt-4">
                                <button
                                    type="button"
                                    onClick={onSubmit}
                                    className="btn-xl w-full mt-4 mb-6"
                                    disabled={loading}
                                >
                                    {"Submit"}
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
